/**
 * Clear reference
 *
 * @param data
 * @returns {any}
 */
export function clone<T>(data: T): T {
  return JSON.parse(JSON.stringify(data));
}
